import * as d3 from 'd3-selection'
import { drag } from 'd3-drag'
import chart from './chart/index.js'

// This builds the top header, which contains the tree search
// and the gantt chart header (date labels)
function header (selection, gantt) {
  selection.each(function () {
    gantt._header = d3.select(this)
                      .append('div')
                        .attr('class', 'gantt-header')

    // Tree search container
    gantt._header.append('div')
                 .attr('class', 'gantt-pane-left')
                 .select(function () {
                   this.appendChild(gantt.options.treeHeader)
                 })

    // Gantt date labels (top section of the actual gantt chart)
    gantt._header.append('div')
                 .attr('class', 'gantt-pane-right gantt-labels')
  })
}

// This contains the tree and the gantt showing the tasks.
// Users should be able to scroll up and down within this container. That should happen
// automatically from the tree magic
function body (selection, gantt) {
  selection.each(function () {
    gantt._body = d3.select(this)
                    .append('div')
                      .attr('class', 'gantt-body')

    gantt._body.node()
               .appendChild(gantt.tree.render().el.node())

    gantt.tree.el.classed('tree-container-light', true)
  })
}

// Bottom section of the gantt, which shows tree buttons and the minibar
function footer (selection, gantt) {
  selection.each(function () {
    gantt._footer = d3.select(this)
                      .append('div')
                        .attr('class', 'gantt-footer')

    gantt._footer.append('div')
                 .attr('class', 'gantt-pane-left')
                 .select(function () {
                   this.appendChild(gantt.options.treeFooter)
                 })

    gantt._footer.append('div')
                  .attr('class', 'gantt-pane-right')
                  .append('svg')
                    .attr('class', 'gantt-mini')
                    .append('g')
                      .attr('transform', `translate(${gantt.dimensions.footer.margin.left}, ${gantt.dimensions.footer.margin.top})`)

  })
}

/* Add a resize handler to control the tree container width
 * This also serves as the border for all the `gantt-pane-left` objects
 * Doing it this way instead of putting a resizer in each tree node `gantt-pane-left`
 */
function resizer (selection, gantt) {
  selection.each(function () {
    var container = d3.select(this)
      , _drag = drag().on('start', e => {
                        container.classed('gantt-pane-resizing', true)
                      })
                      .on('drag', e => {
                        var width = Math.max(0, gantt.dimensions.left.width + e.dx)
                        gantt.setLeftPaneWidth(width)
                      })
                      .on('end', () => {
                        container.classed('gantt-pane-resizing', false)
                        gantt.updateWidthForScrollbars() // Resize the chart in case we're now showing scrollbars
                      })

    container.append('div')
             .attr('class', 'gantt-pane-resizer')
             .call(_drag)
             .style('left', `${gantt.dimensions.left.width}px`)
  })
}

// This builds the overall gantt chart layout. It should be called
// on d3 data join enter. This code should only run once.
export default function (selection, gantt) {
  selection.each(function () {
    var container = d3.select(this)
                      .append('div')
                        .attr('class', 'gantt-container')
                        .classed('gantt-footerless', !gantt.options.showFooter)

    container.call(header, gantt)
             .call(body, gantt)
             .call(footer, gantt)
             .call(resizer, gantt)

    // When the tree data changed, we know the tree layout may have changed, so
    // we also need to adjust the gantt chart
    gantt.tree.on('rebind', data => {
      var nodes = gantt.initiativeData ? gantt.initiativeData.length : 0
      gantt.initiativeData = data.map(d => {
        var n = gantt.tree.get(d.id)
        n._layout = d // Store the tree layout to help us draw the chart

        // Delete the gantt layout on the node, so we can start fresh
        delete n._gantt
        return n
      })

      // Tree layout changed, redraw the minibar
      gantt._redrawMini()

      // Redraw all nodes since the tree changed
      if (nodes !== gantt.initiativeData.length) {
          // Update each node in the chart in case we need to update a descendants wrapper
          gantt._body.selectAll('.node')
                     .selectAll('.gantt-pane-right')
                     .call(chart, gantt)
      }
    })
  })

}
